import { render, staticRenderFns } from "./Genus.vue?vue&type=template&id=8daf17ee&scoped=true&"
import script from "./Genus.vue?vue&type=script&lang=js&"
export * from "./Genus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8daf17ee",
  null
  
)

export default component.exports